import React from "react";
import Marquee from "react-fast-marquee";

export default function EditorialMarquee() {
  return (
    <div className="py-16 md:py-24 border-y border-white/5 bg-[#0B0B0B]" data-testid="marquee">
      <Marquee speed={35} gradient={false}>
        <span className="marquee-text px-10">Strategic Litigation</span>
        <span className="marquee-text px-10">·</span>
        <span className="marquee-text px-10">Practical Solutions</span>
        <span className="marquee-text px-10">·</span>
        <span className="marquee-text px-10">Bombay High Court</span>
        <span className="marquee-text px-10">·</span>
        <span className="marquee-text px-10">Kolhapur Bench</span>
        <span className="marquee-text px-10">·</span>
      </Marquee>
    </div>
  );
}
